import { Modal, Button, ConfigProvider } from "antd";
import { CloseOutlined, WarningOutlined } from "@ant-design/icons";
import "./DeleteEmployeeModal.scss";

interface DeleteEmployeeModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  employeeName: string;
}

const DeleteEmployeeModal: React.FC<DeleteEmployeeModalProps> = ({
  open,
  onCancel,
  onConfirm,
  employeeName,
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered
      className="delete-employee-modal"
      closeIcon={<CloseOutlined className="delete-modal-close-icon" />}
      width={500}
    >
      <div className="delete-employee-modal-content">
        <div className="delete-employee-modal-header">
          <div className="delete-employee-modal-title-container">
            <div className="delete-warning-icon-wrapper">
              <WarningOutlined className="delete-warning-icon" />
            </div>
            <h2 className="delete-employee-modal-title">Delete Employee</h2>
          </div>
        </div>
        <div className="delete-employee-modal-body">
          <p className="delete-warning-text">
            <strong>Warning!</strong> Deleting this employee will also remove
            them from any pending orders and they will no longer be able to sign
            in.
          </p>
          <p className="delete-info-text">
            However, you can still see their history and re-invite them any
            time.
          </p>
        </div>
        <div className="delete-employee-modal-actions">
          <ConfigProvider theme={{ token: { colorPrimary: "#dc2626" } }}>
            <Button
              type="primary"
              onClick={onConfirm}
              className="delete-employee-confirm-button"
            >
              Delete {employeeName}
            </Button>
          </ConfigProvider>
          <Button onClick={onCancel} className="delete-employee-cancel-button">
            Cancel
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteEmployeeModal;
